module.exports = __webpack_public_path__ + "img/19.ef4b2d94.svg";